/* ═══════ FD ORDER-CUTOFF COUNTDOWN ═══════ */
(function(){
  const cutoff = new Date('2026-06-10T23:59:59');  // FD shipping cutoff
  const now = new Date();
  const days = Math.max(0, Math.ceil((cutoff - now) / (1000 * 60 * 60 * 24)));
  const el = document.getElementById('fdDaysLeft');
  if (el) el.textContent = days;
})();

/* ═══════ AGING TIMELINE ═══════ */
const STAGES = [
  {h:0,   color:'#F4EEE3', label:'Day 1',   title:'Day 1 — Clear and basic.',          desc:'Pour the base spirit. Drop in the wood and botanicals. Close the lid & walk away.'},
  {h:24,  color:'#F2E5C0', label:'Day 3',   title:'Day 3 — Light straw.',              desc:'The charred oak\'s woken up. Tannins start lifting color into pale gold — that\'s the wood doing the heavy lifting. Drinkable already.'},
  {h:72,  color:'#E2C783', label:'Week 1',  title:'Week 1 — Honey.',                   desc:'Light amber. Sweet on the nose, soft on the finish. The "after dinner" pour.'},
  {h:120, color:'#B07A30', label:'Week 2+', title:'Week 2+ — Rich amber.',             desc:'Rich amber with a classic bourbon color. Layered, confident — and keeps getting better… slowly.'}
];

function makeBottle(stage, idx, active) {
  return `
    <div class="bottle-unit ${active?'active':''}">
      <img class="bottle-img" src="${window.CRAFTLY_ASSETS}bottle_real_${idx}.png" alt="${stage.label}" loading="lazy">
      <div class="bottle-label">${stage.label}</div>
    </div>`;
}
function renderBottles(activeIdx){
  document.getElementById('agingBottles').innerHTML =
    STAGES.map((s,i) => makeBottle(s, i, i===activeIdx)).join('');
  // Mobile hero bottle (single image cross-fade)
  const hero = document.getElementById('agingHero');
  if (hero) hero.style.backgroundImage = `url(${window.CRAFTLY_ASSETS}bottle_real_${activeIdx}.png)`;
}
const agingSlider = document.getElementById('agingSlider');
const agingTime = document.getElementById('agingTime');
const agingDesc = document.getElementById('agingDesc');
function updateAging(){
  const v = parseInt(agingSlider.value);
  let idx = 0;
  for (let i=0; i<STAGES.length; i++) if (v >= STAGES[i].h) idx = i;
  renderBottles(idx);
  agingTime.textContent = STAGES[idx].title;
  agingDesc.textContent = STAGES[idx].desc;
}
agingSlider.addEventListener('input', updateAging);
renderBottles(0);

/* ═══════ FLAVOR WHEEL ═══════ */
const AXES = ['Smoky','Sweet','Spicy','Woody','Citrus','Floral'];
const WOODS = [
  {name:'Charred Oak', vec:[3,1,2,5,0,0]},
  {name:'Cherry Wood', vec:[1,4,1,3,1,2]},
  {name:'Hickory',     vec:[5,1,2,4,0,0]},
  {name:'Maple',       vec:[1,5,1,3,0,1]},
  {name:'Applewood',   vec:[2,3,1,3,1,2]},
  {name:'Mesquite',    vec:[5,0,3,4,0,0]}
];
const BOTS = [
  {name:'Vanilla',     vec:[0,5,0,1,0,3]},
  {name:'Cinnamon',    vec:[1,3,4,1,0,1]},
  {name:'Orange Peel', vec:[0,2,1,0,5,2]},
  {name:'Birds-Eye',   vec:[2,0,5,0,0,0]},
  {name:'Clove',       vec:[1,1,4,1,0,2]},
  {name:'Star Anise',  vec:[1,2,3,1,1,4]}
];
const REFS = {
  Smoky:[
    {brand:'Lagavulin',type:'16 Year Islay Single Malt',price:115},
    {brand:'Laphroaig',type:'18 Year Islay Single Malt',price:180},
    {brand:'Talisker',type:'18 Year Highland Single Malt',price:195},
    {brand:'Ardbeg',type:'Uigeadail Islay Single Malt',price:110},
  ],
  Sweet:[
    {brand:'Balvenie',type:'DoubleWood 17 Year Speyside',price:165},
    {brand:'Glenmorangie',type:'Nectar D\'Or 12 Year Highland',price:110},
    {brand:'Redbreast',type:'15 Year Irish Single Pot Still',price:140},
    {brand:'Knob Creek',type:'12 Year Kentucky Bourbon',price:105},
  ],
  Spicy:[
    {brand:'Booker\'s',type:'Small Batch Kentucky Bourbon',price:110},
    {brand:'Stagg Jr',type:'Kentucky Straight Bourbon',price:130},
    {brand:'Elijah Craig',type:'Barrel Proof Kentucky Bourbon',price:100},
    {brand:'Michter\'s',type:'US*1 Toasted Barrel Bourbon',price:110},
  ],
  Woody:[
    {brand:'Macallan',type:'15 Year Triple Cask Speyside',price:150},
    {brand:'Glenfarclas',type:'21 Year Speyside Single Malt',price:170},
    {brand:'Blanton\'s',type:'Gold Edition Bourbon',price:150},
    {brand:'GlenDronach',type:'18 Year Allardice Highland',price:220},
  ],
  Citrus:[
    {brand:'Redbreast',type:'12 Year Cask Strength Irish',price:100},
    {brand:'Hibiki',type:'Japanese Harmony Blend',price:130},
    {brand:'Nikka',type:'Taketsuru Pure Malt Japanese',price:130},
    {brand:'Auchentoshan',type:'Three Wood Lowland Single Malt',price:105},
  ],
  Floral:[
    {brand:'Hakushu',type:'12 Year Japanese Single Malt',price:200},
    {brand:'Glenlivet',type:'18 Year Speyside Single Malt',price:130},
    {brand:'Dalwhinnie',type:'15 Year Highland Single Malt',price:100},
    {brand:'Oban',type:'14 Year Highland Single Malt',price:115},
  ],
};

const RADIUS = 110;
function pt(idx, val){
  const a = (idx/AXES.length)*Math.PI*2 - Math.PI/2;
  const r = (val/5)*RADIUS;
  return [Math.cos(a)*r, Math.sin(a)*r];
}
function renderSpiderGrid(){
  let g='', ax='', lb='';
  for (let level=1; level<=5; level++){
    const pts = AXES.map((_,i)=>pt(i,level).join(',')).join(' ');
    g += `<polygon class="grid-poly" points="${pts}"/>`;
  }
  AXES.forEach((name,i)=>{
    const [x,y] = pt(i,5);
    ax += `<line class="axis-line" x1="0" y1="0" x2="${x}" y2="${y}"/>`;
    const lx = Math.cos((i/AXES.length)*Math.PI*2 - Math.PI/2)*(RADIUS+18);
    const ly = Math.sin((i/AXES.length)*Math.PI*2 - Math.PI/2)*(RADIUS+18);
    lb += `<text x="${lx}" y="${ly}" text-anchor="middle" dy="4">${name}</text>`;
  });
  document.getElementById('spiderGrid').innerHTML = g;
  document.getElementById('spiderAxes').innerHTML = ax;
  document.getElementById('spiderLabels').innerHTML = lb;
}
function renderIngredients(){
  const wEl = document.getElementById('ingWoods'), bEl = document.getElementById('ingBotanicals');
  wEl.innerHTML = WOODS.map((w,i)=>`<div class="ing-chip wood" data-type="wood" data-idx="${i}">${w.name}</div>`).join('');
  bEl.innerHTML = BOTS.map((b,i)=>`<div class="ing-chip bot" data-type="bot" data-idx="${i}">${b.name}</div>`).join('');
}
const active = {wood:new Set(), bot:new Set()};
function hashStr(s){let h=0;for(let i=0;i<s.length;i++)h=((h<<5)-h+s.charCodeAt(i))|0;return Math.abs(h)}
function generateName(vec){
  const max = Math.max(...vec);
  const top = AXES.map((n,i)=>({n,v:vec[i]})).sort((a,b)=>b.v-a.v).slice(0,2);
  const adj = {Smoky:'Smoked',Sweet:'Honeyed',Spicy:'Spiced',Woody:'Oaked',Citrus:'Citrus',Floral:'Floral'};
  const noun = ['Old Fashioned','Reserve','Blend','Pour','Manhattan','Whisky','Sour'];
  const seed = top.map(t=>t.n).join('');
  return `The ${adj[top[0].n]||top[0].n} ${adj[top[1].n]||top[1].n} ${noun[hashStr(seed)%noun.length]}`;
}
function generateDesc(vec){
  const top = AXES.map((n,i)=>({n,v:vec[i]})).sort((a,b)=>b.v-a.v).slice(0,3);
  const traits = {
    Smoky:'heavy smoke on the nose',Sweet:'a rich vanilla backbone',
    Spicy:'a slow-burn finish',Woody:'deep oak and char',
    Citrus:'bright citrus brightness',Floral:'an unexpected floral lift'};
  return `Leads with ${traits[top[0].n]}, carried by ${traits[top[1].n]}, finished with ${traits[top[2].n]}.`;
}
function pickRef(vec){
  const top = AXES.map((n,i)=>({n,v:vec[i]})).sort((a,b)=>b.v-a.v)[0].n;
  const refs = REFS[top]; if(!refs) return null;
  const seed = AXES.map((n,i)=>n+vec[i]).join('');
  return refs[hashStr(seed)%refs.length];
}
function update(){
  let vec = AXES.map(()=>0); let count = 0;
  active.wood.forEach(i=>{WOODS[i].vec.forEach((v,j)=>vec[j]+=v); count++});
  active.bot.forEach(i=>{BOTS[i].vec.forEach((v,j)=>vec[j]+=v); count++});
  if (count) vec = vec.map(v=>Math.min(5,v/count*1.3));

  const nameEl   = document.getElementById('whiskeyName');
  const descEl   = document.getElementById('whiskeyDesc');
  const refEl    = document.getElementById('whiskeyRef');
  const polyEl   = document.getElementById('spiderPoly');
  const lockEl   = document.getElementById('spiderLock');
  const bottleEl = document.getElementById('flavorBottle');
  const cocktailEl = document.getElementById('flavorCocktail');
  const countEl  = document.getElementById('ingredientCount');
  if (countEl) countEl.textContent = count;

  // Always render the polygon — empty pattern when 0 ingredients, partial when <3
  polyEl.setAttribute('points',
    AXES.map((_,i)=>pt(i,vec[i]).join(',')).join(' '));
  if (lockEl){
    if (count < 3){
      lockEl.style.display = 'block';
      lockEl.querySelector('#ingredientCount').textContent = count;
    } else {
      lockEl.style.display = 'none';
    }
  }
  if (count < 3){
    nameEl.textContent = count === 0 ? 'Untouched Base Spirit' : 'Building...';
    descEl.textContent = count === 0
      ? 'Tap a wood and a botanical below to see his profile take shape.'
      : `${count}/3 chosen · pick more to see the bottled equivalent.`;
    refEl.innerHTML = '';
    if (bottleEl) bottleEl.style.backgroundImage = `url(${window.CRAFTLY_ASSETS}bottle_real_${Math.min(count,2)}.png)`;
    if (cocktailEl) cocktailEl.style.opacity = '0.4';
    return;
  }

  // Bottle color tint based on flavor intensity (pick darker bottle as more flavors stack)
  const intensity = Math.min(5, Math.round(count - 1));  // 3→2, 4→3, 5→4, 6→5...
  if (bottleEl) bottleEl.style.backgroundImage = `url(${window.CRAFTLY_ASSETS}bottle_real_${Math.min(intensity,5)}.png)`;

  // Cocktail color tint based on dominant axis
  const top = AXES.map((n,i)=>({n,v:vec[i]})).sort((a,b)=>b.v-a.v)[0].n;
  const cocktailMap = {Smoky:'recipe_old_fashioned',Sweet:'recipe_golden_sour',Spicy:'recipe_old_fashioned',
                       Woody:'recipe_old_fashioned',Citrus:'recipe_golden_sour',Floral:'recipe_golden_sour'};
  if (cocktailEl){
    cocktailEl.style.backgroundImage = `url(${window.CRAFTLY_ASSETS}${cocktailMap[top] || 'recipe_old_fashioned'}.png)`;
    cocktailEl.style.opacity = '1';
  }

  nameEl.textContent = generateName(vec);
  descEl.textContent = generateDesc(vec);
  const ref = pickRef(vec);
  if (ref){
    refEl.innerHTML = `
      <div class="readout-ref-label">Bottled equivalent</div>
      <div class="readout-ref-price">$${ref.price}+ retail</div>`;
  }
}
document.addEventListener('click', e=>{
  if (!e.target.classList.contains('ing-chip')) return;
  const hint = document.getElementById('ingTapHint');
  if (hint) hint.classList.add('done');   // dismiss tap-hint on first interaction
  const t = e.target.dataset.type, i = parseInt(e.target.dataset.idx);
  const set = active[t];
  if (set.has(i)){ set.delete(i); e.target.classList.remove('active') }
  else { set.add(i); e.target.classList.add('active') }
  update();
});
renderSpiderGrid();
renderIngredients();
update();

/* ═══════ BUNDLE BUILDER ═══════ */
(function(){
  const REWARD = 149;
  const SHIP_FREE = 100;
  const btTotal = document.getElementById('btTotal');
  const btBar   = document.getElementById('btBar');
  const btMeta  = document.getElementById('btMeta');
  const reward  = document.getElementById('reward');
  const rewardStatus = document.getElementById('rewardStatus');
  const builderCta = document.getElementById('builderCta');
  const bcPrice = document.getElementById('bcPrice');
  
  

  function recompute(){
    const baseEls = document.querySelectorAll('input[name="base"]:checked');
    const base = [...baseEls].reduce((s,el)=>s+parseFloat(el.value),0);
    const noBase = baseEls.length === 0;
    let upTotal = 0;
    document.querySelectorAll('.upg-row[data-price] input:checked').forEach(i=>{
      upTotal += parseFloat(i.closest('.upg-row').dataset.price) || 0;
    });
    const total = base + upTotal;
    if (btTotal) btTotal.textContent = `$${total.toFixed(2)}`;
    const atcEl = document.getElementById('atcTotal');
    if (atcEl) atcEl.textContent = `$${total.toFixed(2)}`;
    if (bcPrice) bcPrice.textContent = `$${total.toFixed(2)}`;
    const pct = Math.min(100, total/REWARD*100);
    if (btBar){ btBar.style.width = pct + '%'; btBar.classList.toggle('maxed', total >= REWARD); }
    if (total >= REWARD){
      if (btMeta) btMeta.innerHTML = '<strong>🎁 Free Vodka Flavoring & Cocktail Set unlocked!</strong>';
      if (reward) reward.classList.add('unlocked');
      if (rewardStatus) rewardStatus.innerHTML = '<span class="dot"></span> <strong>✓ Unlocked.</strong> Ships free in your box.';
      if (builderCta) builderCta.classList.add('unlocked');
    } else if (noBase){
      if (btMeta) btMeta.innerHTML = 'Pick a kit to start';
      if (reward) reward.classList.remove('unlocked');
      if (rewardStatus) rewardStatus.innerHTML = '<span class="dot"></span> Pick a kit to start';
      if (builderCta) builderCta.classList.remove('unlocked');
    } else {
      const need = (REWARD - total).toFixed(2);
      const needShip = (SHIP_FREE - total).toFixed(2);
      if (btMeta) btMeta.innerHTML = total >= SHIP_FREE
        ? `<span style="color:var(--kraft-light)">✓ Free shipping</span> · Add <strong>$${need}</strong> for the Vodka Kit`
        : `Add <strong>$${needShip}</strong> for free shipping · <strong>$${need}</strong> for the Vodka Kit`;
      if (reward) reward.classList.remove('unlocked');
      if (rewardStatus) rewardStatus.innerHTML = `<span class="dot"></span> Add <strong>$${need}</strong> more to unlock`;
      if (builderCta) builderCta.classList.remove('unlocked');
    }
  }
  document.addEventListener('change', e=>{ if (e.target.matches('input[type="checkbox"], input[type="radio"]')) recompute(); });
  document.addEventListener('change', e=>{
    if (!e.target.matches('.upg-row input[type=checkbox]')) return;
    const row = e.target.closest('.upg-row');
    if (row) row.classList.toggle('checked', e.target.checked);
  });
  // Set initial visual state for pre-checked rows
  document.querySelectorAll('.upg-row input:checked').forEach(i=>{
    i.closest('.upg-row').classList.add('checked');
  });
  /* go-big moved to bottom */
  recompute();
})();

/* ═══════ PDP GALLERY + LIGHTBOX ═══════ */
function openLightbox(src){
  const lb = document.getElementById('lightbox');
  const img = document.getElementById('lightboxImg');
  if (!lb || !img) return;
  img.src = src;
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeLightbox(){
  const lb = document.getElementById('lightbox');
  if (lb){ lb.classList.remove('open'); document.body.style.overflow = ''; }
}
window.openLightbox = openLightbox;
window.closeLightbox = closeLightbox;
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });

/* ═══════ PDP GALLERY CAROUSEL (swipe · dots · thumbs · per-photo badge) ═══════ */
(function(){
  const car = document.getElementById('pdpCarousel');
  if (!car) return;
  const dots   = Array.from(document.querySelectorAll('#pdpDots .pdp-dot'));
  const thumbs = Array.from(document.querySelectorAll('#pdpThumbs .pdp-thumb'));
  const slides = Array.from(car.querySelectorAll('.pdp-slide'));
  const badge  = document.getElementById('pdpBadge');

  function setBadge(text){
    if (!badge || !text) return;
    const parts = text.split('·').map(s=>s.trim());
    // only render the big-number style when part 1 is actually a short number (e.g. "#1")
    const isNum = parts.length === 2 && /^#?\d+$/.test(parts[0].replace(/\s/g,''));
    if (isNum){
      badge.innerHTML = `<span class="pdp-badge-num">${parts[0]}</span>`
                      + `<span class="pdp-badge-line">${parts[1]}</span>`;
    } else {
      badge.innerHTML = parts.map(p=>`<span class="pdp-badge-line">${p}</span>`).join('');
    }
  }
  const activeIndex = ()=> Math.round(car.scrollLeft / car.clientWidth);
  function sync(){
    const i = Math.min(activeIndex(), slides.length - 1);
    dots.forEach((d,n)=> d.classList.toggle('active', n === i));
    thumbs.forEach((t,n)=> t.classList.toggle('active', n === i));
    if (slides[i]) setBadge(slides[i].dataset.badge);
  }
  let raf;
  car.addEventListener('scroll', ()=>{
    cancelAnimationFrame(raf); raf = requestAnimationFrame(sync);
  }, {passive:true});
  function goTo(n){ car.scrollTo({left: n * car.clientWidth, behavior:'smooth'}); }
  dots.forEach((d,n)=> d.addEventListener('click', ()=> goTo(n)));
  thumbs.forEach((t,n)=> t.addEventListener('click', ()=> goTo(n)));
  sync();  // set initial badge from slide 1
})();

/* ═══════ MILESTONE BAR — free-shipping progress, reads mini-builder ═══════ */
(function(){
  const SHIP = 99;
  const fill = document.getElementById('msProgressFill');
  const total = document.getElementById('msTotal');
  const msg = document.getElementById('msMsg');
  const marker = document.querySelector('.milestone-bar .ms-marker');
  function refresh(){
    const sel = document.querySelector('input[name="mb-tier"]:checked')
             || document.querySelector('input[name="mb-tier"]');
    const t = sel ? (parseFloat(sel.dataset.price) || 0) : 0;
    if (total) total.textContent = `$${t.toFixed(2)}`;
    if (fill)  fill.style.width = Math.min(100, t/SHIP*100) + '%';
    if (marker) marker.classList.toggle('passed', t >= SHIP);
    if (!msg) return;
    if (t >= SHIP) msg.innerHTML = '<span style="color:var(--forest)">✓ Free shipping unlocked</span>';
    else if (t > 0) msg.innerHTML = `Add <strong>$${(SHIP-t).toFixed(2)}</strong> for free shipping`;
    else msg.textContent = 'Pick a gift above';
  }
  document.addEventListener('change', e=>{ if (e.target.name === 'mb-tier') refresh(); });
  setTimeout(refresh, 100);
})();

/* ═══════ TAB SWITCH (Live / Backup) ═══════ */
document.body.dataset.view = 'live';
document.querySelectorAll('.tab').forEach(t => t.addEventListener('click', () => {
  document.body.dataset.view = t.dataset.tab;
  document.querySelectorAll('.tab').forEach(x => x.classList.toggle('active', x === t));
  window.scrollTo({top:0, behavior:'smooth'});
}));

/* ═══════ GO BIG buttons (per-step + master) ═══════ */
document.querySelectorAll('.go-big[data-target]').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    const grp = btn.dataset.target;
    // Skip disabled (sold-out) inputs entirely
    const inputs = [...document.querySelectorAll(`.upg-list[data-group="${grp}"] input[type="checkbox"]`)].filter(i => !i.disabled);
    const allOn = inputs.every(i=>i.checked);
    inputs.forEach(i=>{
      i.checked = !allOn;
      i.dispatchEvent(new Event('change',{bubbles:true}));
    });
    btn.classList.toggle('active', !allOn);
    btn.querySelector('span').textContent = !allOn ? '✓' : '+';
  });
});

const builderMaster = document.getElementById('builderMaster');
if (builderMaster) builderMaster.addEventListener('click', ()=>{
  document.querySelectorAll('.upg-row input[type="checkbox"]').forEach(i=>{
    if (i.disabled) return;  // skip sold-out items
    if (!i.checked){
      i.checked = true;
      i.dispatchEvent(new Event('change',{bubbles:true}));
    }
  });
  builderMaster.classList.add('done');
  builderMaster.querySelector('.bm-label').textContent = '✓ Everything added';
  builderMaster.querySelector('.bm-headline').textContent = 'Click your kit total below to check out';
});

/* ═══════ TRACKING PARAM PRESERVATION ═══════ */
// Capture click IDs + UTMs on landing → keep them across cart → checkout so Meta/
// Google can attribute the purchase. Without this, gclid/fbclid die at /cart.
const TRACK_PARAMS = ['gclid','fbclid','wbraid','gbraid','msclkid','ttclid',
                      'utm_source','utm_medium','utm_campaign','utm_content','utm_term',
                      'irclickid','tw_source'];
(function captureTracking(){
  const u = new URLSearchParams(location.search);
  TRACK_PARAMS.forEach(p => {
    if (u.has(p)){
      try { sessionStorage.setItem('_t_'+p, u.get(p)); } catch(e){}
      document.cookie = `_t_${p}=${encodeURIComponent(u.get(p))};path=/;max-age=2592000;SameSite=Lax`;
    }
  });
})();
function buildTrackingQuery(){
  const parts = [];
  TRACK_PARAMS.forEach(p => {
    let v = null;
    try { v = sessionStorage.getItem('_t_'+p); } catch(e){}
    if (!v){
      const m = document.cookie.match(new RegExp('_t_'+p+'=([^;]+)'));
      if (m) v = decodeURIComponent(m[1]);
    }
    if (v) parts.push(`${p}=${encodeURIComponent(v)}`);
  });
  return parts.join('&');
}

/* ═══════ ADD TO CART (Shopify /cart/add.js) ═══════ */
const REWARD_THRESHOLD = 149;
const REWARD_VARIANT_ID = 41058190885033;   // Vodka Flavoring & Cocktail Set
const REWARD_DISCOUNT_CODE = 'BUILDER149';

function collectBuilderItemsAndTotal(){
  const items = [];
  let total = 0;
  document.querySelectorAll('.upg-row').forEach(row=>{
    const input = row.querySelector('input[type="checkbox"]');
    if (!input || !input.checked || input.disabled) return;
    const vid = input.dataset.variantId || row.dataset.variantId;
    if (!vid) return;
    items.push({id: parseInt(vid, 10), quantity: 1});
    // Sum price: kits use input.value, upgrades use row data-price
    if (input.name === 'base'){
      total += parseFloat(input.value) || 0;
    } else if (row.dataset.price){
      total += parseFloat(row.dataset.price) || 0;
    }
  });
  return {items, total};
}
async function addBuilderToCart(e){
  if (e) { e.preventDefault(); e.stopPropagation(); }
  const {items, total} = collectBuilderItemsAndTotal();
  console.log('[craftly] ATC fired, items:', items, 'total:', total);
  if (!items.length) { alert('Pick at least one item.'); return; }
  const qualifies = total >= REWARD_THRESHOLD;
  if (qualifies){
    items.push({id: REWARD_VARIANT_ID, quantity: 1});
    console.log('[craftly] threshold reached — adding reward kit + applying', REWARD_DISCOUNT_CODE);
  }
  // Fire Meta + Google AddToCart events BEFORE redirect (so they don't get lost on nav)
  try {
    if (typeof fbq === 'function'){
      fbq('track', 'AddToCart', {
        value: total, currency: 'USD',
        content_ids: items.map(i => i.id),
        content_type: 'product',
        contents: items.map(i => ({id: i.id, quantity: i.quantity}))
      });
    }
  } catch(err){ console.warn('fbq error', err); }
  try {
    if (typeof gtag === 'function'){
      gtag('event', 'add_to_cart', {
        currency: 'USD', value: total,
        items: items.map(i => ({item_id: i.id, quantity: i.quantity}))
      });
    }
  } catch(err){ console.warn('gtag error', err); }
  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({items})
    });
    const data = await r.json().catch(()=>({}));
    console.log('[craftly] /cart/add status:', r.status, data);
    if (!r.ok) {
      alert(data.description || 'Could not add to cart. Some items may not be available.');
      return;
    }
    // Build redirect with tracking params preserved (gclid/fbclid/utms)
    const tracking = buildTrackingQuery();
    const cartQuery = 'from=whiskey-kit' + (tracking ? '&' + tracking : '');
    window.location.href = qualifies
      ? `/discount/${REWARD_DISCOUNT_CODE}?redirect=` + encodeURIComponent('/cart?' + cartQuery)
      : '/cart?' + cartQuery;
  } catch (err) {
    console.error('[craftly] ATC network error', err);
    alert('Network error — try again.');
  }
}
window.addBuilderToCart = addBuilderToCart;

/* ═══════ MINI BUILDER (3-tier gift selector) ═══════ */
function miniBuilderSelected(){
  const sel = document.querySelector('input[name="mb-tier"]:checked');
  return sel || document.querySelector('input[name="mb-tier"]');
}
// Update CTA button label when a tier is picked
document.querySelectorAll('input[name="mb-tier"]').forEach(r=>{
  r.addEventListener('change', ()=>{
    const cta = document.getElementById('miniBuilderCta');
    if (cta && r.dataset.label) cta.textContent = r.dataset.label;
  });
});
async function miniBuilderAddToCart(e){
  if (e){ e.preventDefault(); e.stopPropagation(); }
  const sel = miniBuilderSelected();
  if (!sel){ alert('Pick a gift option.'); return; }
  const items = sel.dataset.variants.split(',')
    .map(v=>({id: parseInt(v.trim(),10), quantity:1}));
  const total = parseFloat(sel.dataset.price) || 0;
  const code = sel.dataset.discount || '';
  console.log('[craftly] mini-builder ATC:', sel.value, 'items:', items, 'discount:', code);
  // Tracking events before nav
  try{ if(typeof fbq==='function') fbq('track','AddToCart',{
    value:total,currency:'USD',content_ids:items.map(i=>i.id),content_type:'product',
    contents:items.map(i=>({id:i.id,quantity:i.quantity}))}); }catch(err){}
  try{ if(typeof gtag==='function') gtag('event','add_to_cart',{
    currency:'USD',value:total,items:items.map(i=>({item_id:i.id,quantity:i.quantity}))}); }catch(err){}
  try{
    const r = await fetch('/cart/add.js',{method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items})});
    const data = await r.json().catch(()=>({}));
    if(!r.ok){ alert(data.description||'Could not add to cart.'); return; }
    const tracking = buildTrackingQuery();
    const cartQuery = 'from=whiskey-kit' + (tracking ? '&'+tracking : '');
    // Apply bundle discount code if this tier has one
    window.location.href = code
      ? `/discount/${code}?redirect=` + encodeURIComponent('/cart?'+cartQuery)
      : '/cart?' + cartQuery;
  }catch(err){
    console.error('[craftly] mini-builder ATC error', err);
    alert('Network error — try again.');
  }
}
window.miniBuilderAddToCart = miniBuilderAddToCart;

// Delegated click on document so theme wrappers can't intercept
document.addEventListener('click', function(e){
  const t = e.target.closest('.builder-total, #builderCta, .builder-cta');
  if (!t) return;
  console.log('[craftly] builder-total/CTA click intercepted');
  addBuilderToCart(e);
}, true);

const btTotalBox = document.querySelector('.builder-total');
if (btTotalBox) btTotalBox.style.cursor = 'pointer';
console.log('[craftly] ATC ready. Test in console: addBuilderToCart()');

/* ═══════ CTA LINKING ═══════ */
function scrollToId(id){
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({behavior:'smooth', block:'start'});
}
document.querySelectorAll('button').forEach(btn=>{
  const txt = (btn.textContent||'').toLowerCase();
  if (btn.classList.contains('tab')) return; // tabs handled separately
  if (btn.classList.contains('builder-master') || btn.classList.contains('builder-cta')) return;
  if (btn.classList.contains('go-big')) return;
  if (/build (his |your |the |it)?/i.test(txt) && !btn.classList.contains('cowboy-cta')){
    btn.addEventListener('click', e => { e.preventDefault(); scrollToId('builder'); });
  } else if (/how it works/i.test(txt) || /see what/i.test(txt) || /compare/i.test(txt)){
    btn.addEventListener('click', e => { e.preventDefault(); scrollToId('how-it-works'); });
  } else if (/be one of them/i.test(txt)){
    btn.addEventListener('click', e => { e.preventDefault(); scrollToId('builder'); });
  } else if (/skip socks|stop scrolling|full send/i.test(txt)){
    btn.addEventListener('click', e => { e.preventDefault(); scrollToId('builder'); });
  }
});
// Sticky milestone CTA + cowboy hero
const msCta = document.getElementById('msCta');
if (msCta) msCta.addEventListener('click', () => scrollToId('builder'));
document.querySelectorAll('.cowboy-cta:not(.outline)').forEach(b => {
  b.addEventListener('click', () => scrollToId('builder'));
});
document.querySelectorAll('.cowboy-cta.outline').forEach(b => {
  b.addEventListener('click', () => scrollToId('how-it-works'));
});

/* ═══════ SCROLL DOTS INDICATOR ═══════ */
document.querySelectorAll('.scroll-dots[data-track]').forEach(dotsEl => {
  const trackName = dotsEl.dataset.track;
  // find the matching scrollable container — sibling or parent's child
  const container = dotsEl.parentElement.querySelector('.' + trackName) ||
                    dotsEl.previousElementSibling;
  if (!container) return;
  const cards = container.children;
  // build dots
  for (let i = 0; i < cards.length; i++) {
    const d = document.createElement('span');
    d.className = 'dot' + (i === 0 ? ' active' : '');
    dotsEl.appendChild(d);
  }
  // update active dot on scroll
  let raf;
  container.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const cardWidth = cards[0]?.getBoundingClientRect().width || 1;
      const gap = parseFloat(getComputedStyle(container).gap) || 0;
      const idx = Math.round(container.scrollLeft / (cardWidth + gap));
      [...dotsEl.children].forEach((d, i) => d.classList.toggle('active', i === idx));
    });
  });
});

/* ═══════ HONEST REVIEWS MODAL ═══════ */


/* ═══════ HONEST REVIEWS MODAL · DOMContentLoaded-safe ═══════ */
function initReviewsModal(){
  const modal = document.getElementById('reviewsModal');
  if (!modal) return;
  function open(){ modal.classList.add('open'); document.body.style.overflow='hidden'; }
  function close(){ modal.classList.remove('open'); document.body.style.overflow=''; }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('.open-reviews-modal, #openReviews, .see-more-reviews');
    if (trigger){ e.preventDefault(); open(); return; }
    if (e.target.closest('[data-close-modal]')){ close(); }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') close(); });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReviewsModal);
} else {
  initReviewsModal();
}

/* ═══════ PRODUCT DETAILS MODAL ═══════ */
const __productCache = {};
async function openProductModal(handle, ev){
  if (ev) { ev.preventDefault(); ev.stopPropagation(); }
  const modal = document.getElementById('productModal');
  const body = document.getElementById('productModalBody');
  if (!modal || !body) return;
  body.innerHTML = '<div class="product-modal-loading">Loading…</div>';
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
  try {
    // Cache-bust on every fetch so price/title updates from Shopify show immediately
    const r = await fetch(`/products/${handle}.js?t=${Date.now()}`);
    if (!r.ok) throw new Error('Product not found');
    const data = await r.json();
    __productCache[handle] = data;
    // Clean marketing suffixes like "(70% OFF Deal)" out of the displayed title
    const cleanTitle = (data.title || '').replace(/\s*\([^)]*\)\s*$/, '').trim();
    const img = data.featured_image || (data.images && data.images[0]) || '';
    const fullImg = img.startsWith('//') ? 'https:' + img : img;
    const price = '$' + (data.price/100).toFixed(2);
    // Show compare-at price (strikethrough) if Shopify has one
    const compareAt = data.compare_at_price ? `$${(data.compare_at_price/100).toFixed(2)}` : null;
    const priceHtml = compareAt
      ? `<span style="text-decoration:line-through;color:var(--ink-mute);font-weight:400;margin-right:8px">${compareAt}</span>${price}`
      : price;
    body.innerHTML = `
      ${fullImg ? `<div class="pm-photo" style="background-image:url(${fullImg})"></div>` : ''}
      <div class="pm-name">${cleanTitle}</div>
      <div class="pm-price">${priceHtml}</div>
      <div class="pm-desc">${data.description || data.body_html || ''}</div>
    `;
  } catch (e) {
    body.innerHTML = '<div class="product-modal-loading" style="color:#9c2b2b">Couldn’t load product details. Sorry.</div>';
    console.error('[craftly] product modal error', e);
  }
}
window.openProductModal = openProductModal;
function closeProductModal(){
  const m = document.getElementById('productModal');
  if (m){ m.classList.remove('open'); document.body.style.overflow = ''; }
}
window.closeProductModal = closeProductModal;
document.addEventListener('keydown', e => {
  if (e.key === 'Escape'){
    const m = document.getElementById('productModal');
    if (m && m.classList.contains('open')){ m.classList.remove('open'); document.body.style.overflow = ''; }
  }
});

/* ═══════ RECIPE INSTRUCTIONS MODAL ═══════ */
const RECIPES = {
  'golden-sour': {
    name: 'Golden Sunset <em>Sour</em>',
    meta: 'Summer · Easy · Day 3',
    occasion: 'Best for: a backyard Sunday with bright sun. Tastes like the lemonade he wishes the bar served.',
    ingredients: [
      '2 oz custom-infused whiskey (Orange Peel + Vanilla + Applewood)',
      '¾ oz fresh lemon juice',
      '½ oz simple syrup (1:1 sugar/water)',
      '2 dashes Angostura bitters (optional)',
      'Lemon wheel + cherry to garnish'
    ],
    steps: [
      'Add whiskey, lemon juice, simple syrup, and bitters to a shaker with ice.',
      'Shake hard for 12 seconds — until the shaker frosts over.',
      'Double-strain into a chilled rocks glass over fresh ice.',
      'Garnish with a lemon wheel and a cherry. Sip immediately.'
    ]
  },
  'old-fashioned': {
    name: 'Smoked Highland <em>Old Fashioned</em>',
    meta: 'Classic · Bold · Day 5',
    occasion: 'Best for: a porch chair, a quiet evening, and a cigar he\'s been saving.',
    ingredients: [
      '2 oz custom-infused whiskey (Mesquite + Charred Oak + Cinnamon)',
      '½ tsp brown sugar OR one sugar cube',
      '2–3 dashes Angostura bitters',
      'Splash of warm water',
      'Orange peel for garnish'
    ],
    steps: [
      'In a rocks glass, muddle the sugar cube with bitters and a splash of warm water until dissolved.',
      'Add whiskey and one large ice cube.',
      'Stir gently for 20 seconds — slow, patient, no shaking.',
      'Express the orange peel oil over the glass, then drop it in. Sip slow.'
    ]
  },
  'chai': {
    name: 'Chai-Spiced <em>Bourbon Chill</em>',
    meta: 'Fall · Warming · Day 5',
    occasion: 'Best for: the first cold night of October. The pour you keep on the kitchen counter.',
    ingredients: [
      '2 oz custom-infused whiskey (Star Anise + Cinnamon + Clove + Maple)',
      '½ oz maple syrup (real, not pancake)',
      '¾ oz fresh orange juice',
      '1 dash orange bitters',
      'Orange zest curl + cinnamon stick to garnish'
    ],
    steps: [
      'Add whiskey, maple syrup, orange juice, and bitters to a mixing glass with ice.',
      'Stir for 20 seconds until well chilled but not over-diluted.',
      'Strain into a rocks glass over one large ice cube.',
      'Express the orange zest, drop in a cinnamon stick. Slow sip.'
    ]
  },
  'cherry': {
    name: 'Cherry Bourbon <em>Neat</em>',
    meta: 'Dessert · Smooth · Day 5',
    occasion: 'Best for: after the kids are asleep. The pour that signals the day is finally yours.',
    ingredients: [
      '2 oz custom-infused whiskey (Cherry Wood + Vanilla + Maple)',
      '1 brandied cherry (Luxardo if you can find it)',
      'No mixer, no ice — just the pour'
    ],
    steps: [
      'Pour 2 oz of your custom whiskey into a heavy rocks glass.',
      'Drop in one brandied cherry (or skip — it\'s already there in the wood).',
      'Hold the glass. Smell first. Then sip slow.',
      'No rush. This one\'s for the second pour, not the first.'
    ]
  },
  'fireside': {
    name: 'The Fireside <em>Sipper</em>',
    meta: 'Winter · Fiery · Day 7',
    occasion: 'Best for: snowy night, real fire, deep chair. The bottle for milestone evenings.',
    ingredients: [
      '2 oz custom-infused whiskey (Hickory + Bird\'s-Eye Chili + Clove)',
      'No mixer. No ice. No garnish.',
      'A heavy crystal glass that thunks when you set it down'
    ],
    steps: [
      'Pour 2 oz into the heaviest glass you own.',
      'Hold it for 60 seconds — let the warmth of your hand bring the aromas forward.',
      'Smell. Then sip — small, slow, let it sit.',
      'Talk to no one. Or to one person. Not more.'
    ]
  },
  'orchard': {
    name: 'The Orchard <em>Highball</em>',
    meta: 'Spring · Light · Day 3',
    occasion: 'Best for: an early-summer dinner on the patio. The whiskey that drinks like a wine person made it.',
    ingredients: [
      '2 oz custom-infused whiskey (Applewood + Star Anise + Orange Peel)',
      '4 oz cold soda water',
      '¼ oz simple syrup (optional)',
      'Lemon wheel + thyme sprig'
    ],
    steps: [
      'Build directly in a tall highball glass: ice, whiskey, simple syrup.',
      'Top with cold soda water — pour gentle, don\'t kill the bubbles.',
      'Stir once with a long spoon, top to bottom.',
      'Garnish with lemon wheel and a thyme sprig. Long sip.'
    ]
  }
};

function openRecipeModal(id, ev){
  if (ev){ ev.preventDefault(); ev.stopPropagation(); }
  const modal = document.getElementById('recipeModal');
  const body = document.getElementById('recipeModalBody');
  if (!modal || !body) return;
  const r = RECIPES[id];
  if (!r) { console.error('[craftly] no recipe:', id); return; }
  body.innerHTML = `
    <h3>${r.name}</h3>
    <div class="rm-meta">${r.meta}</div>
    <h4>Ingredients</h4>
    <ul>${r.ingredients.map(i=>`<li>${i}</li>`).join('')}</ul>
    <h4>Method</h4>
    <ol>${r.steps.map(s=>`<li>${s}</li>`).join('')}</ol>
    <div class="rm-occasion">${r.occasion}</div>
  `;
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
}
window.openRecipeModal = openRecipeModal;
function closeRecipeModal(){
  const m = document.getElementById('recipeModal');
  if (m){ m.classList.remove('open'); document.body.style.overflow = ''; }
}
window.closeRecipeModal = closeRecipeModal;
document.addEventListener('keydown', e => {
  if (e.key === 'Escape'){
    const m = document.getElementById('recipeModal');
    if (m && m.classList.contains('open')){ m.classList.remove('open'); document.body.style.overflow = ''; }
  }
});

/* ═══════ STICKY BOTTOM BAR — appears after scrolling past the kit selector ═══════ */
(function(){
  const selector = document.getElementById('miniBuilder');
  const bar = document.getElementById('milestoneBar');
  if (!selector || !bar) return;
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      // show once the selector has scrolled fully above the viewport top
      const scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('visible', scrolledPast);
    });
  }, { threshold: 0 });
  io.observe(selector);
})();

/* ═══════ URGENCY BAR ROTATION ═══════ */
(function(){
  const msgs = document.querySelectorAll('#urgencyBar .ub-msg');
  if (msgs.length < 2) return;
  let idx = 0;
  setInterval(() => {
    msgs[idx].classList.remove('ub-active');
    idx = (idx + 1) % msgs.length;
    msgs[idx].classList.add('ub-active');
  }, 4000);
})();
